import React from 'react';
import { useTranslation } from 'react-i18next';
import { dateinText } from '../../../helpers/dates';
import Money from '../Money/Money';
import RetinaImg from '../../RetinaImg/RetinaImg';
import styles from './ActivityItem.module.css';

const ActivityItem = ({ activity, language, showBorder = true }) => {
  const { t } = useTranslation();

  const getActivityTitle = (activity) => {
    switch (activity.type) {
      case 'OWN_COMMISSION':
        return 'Comision por venta direta';
      case 'NETWORK_COMMISSION':
        return 'Comision por red';
      case 'PRIZE':
        return t('prize.' + activity.prize.goalType + '_' + activity.prize.assignedTo + '_title');
      case 'WITHDRAWAL':
        return 'Transferencia enviada';
      default:
        return null;
    }
  };

  const getActivityDescription = (activity) => {
    switch (activity.type) {
      case 'OWN_COMMISSION':
        return 'Reservacion en ' + activity.description;
      case 'NETWORK_COMMISSION':
        return 'Reserva via Promotor Nivel ' + activity.description;
      case 'PRIZE':
        return t(
          'prize.' + activity.prize.goalType + '_' + activity.prize.assignedTo + '_description',
          {
            name: activity.description,
          },
        );
      case 'WITHDRAWAL':
        return 'Cuenta personal';
      default:
        return null;
    }
  };

  const getActivityTypeIcon = (type) => {
    switch (type) {
      case 'OWN_COMMISSION':
        return (
          <RetinaImg src='../../images/money.png' alt='Avatar de usuario' width={24} height={24} />
        );
      case 'NETWORK_COMMISSION':
        return (
          <RetinaImg
            src='../../images/currency.png'
            alt='Avatar de usuario'
            width={24}
            height={24}
          />
        );
      case 'PRIZE':
        return (
          <RetinaImg src='../../images/prize.png' alt='Avatar de usuario' width={24} height={24} />
        );
      case 'WITHDRAWAL':
        return (
          <RetinaImg
            src='../../images/withdrawal.png'
            alt='Avatar de usuario'
            width={24}
            height={24}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className='row m-0'>
      <div className={`col-12 ${styles.item} ${showBorder ? styles.borderBottom : ''} px-1`}>
        <div className='row'>
          <div className='col-auto my-auto'>{getActivityTypeIcon(activity.type)}</div>
          <div className='col px-0'>
            <div className='text-tertiary font-small fw-600'>{getActivityTitle(activity)}</div>
            {activity.description && (
              <div className='font-smaller text-secondary'>{getActivityDescription(activity)}</div>
            )}
          </div>
          <div className='col-auto text-right'>
            <div className='text-green font-small fw-500'>
              <Money
                value={activity.amount}
                lowDecimals
                decimal={false}
                showPositiveNegative={true}
              />
            </div>
            <div className='font-smaller text-secondary'>{dateinText(activity.date, language)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;
